/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

const postsColor = "#9AB878";
const postsClrDark = "#5E981D";

import { container } from "assets/jss/material-kit-pro-react.jsx";

const woodImg = require("assets/img/wood0.jpg");
const bodyHeight = {
  minHeight: "5.5rem",
  maxHeight: "5.5rem",
};

export const mlTextBox = {
  "&:hover": {
    border: `1px solid ${postsColor}`,
  },
  "&:focus": {
    border: `1px solid ${postsClrDark}`,
  },
  border: "1px solid #D0D0D0",
  borderRadius: "3px",
  padding: "10px",
  ...bodyHeight,
  backgroundColor: "white",
};

const styles = (theme) => {
  const likeColor = theme.palette.warning.main;
  return {
    "@global": {
      "*::-webkit-scrollbar": {
        width: "0.4em",
      },
      "*::-webkit-scrollbar-track": {
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.35)",
        outline: "1px solid slategrey",
      },
    },

    postsBoard: {
      ...container,
      backgroundImage: `url(${woodImg})`,
      backgroundRepeat: "repeat",
      borderRadius: "8px",
      paddingBottom: "1.5rem",
      "@media (max-width: 360px)": {
        padding: 0,
        margin: 0,
      },
      margin: "1rem -1rem",
    },

    postPanelPaper: {
      backgroundColor: "#F9F9DA",
      borderRadius: 0,
      padding: 0,
      "@media (max-width: 767px)": {
        minWidth: "95%",
      },
      minWidth: "33.25rem",
    },

    panelBackdrop: {
      backgroundColor: "#000000B5",
    },

    panelTitle: {
      height: "1.5rem",
    },

    panelBody: {
      padding: "0 0 1rem",
    },

    closeButton: {
      backgroundColor: "#252850",
      color: "white",
    },

    postIt: {
      width: "90%",
      maxHeight: "13rem",
      minHeight: "13rem",
      margin: "2rem auto 0.5rem",
    },

    postItInPanel: {
      "@media (min-width: 768px)": {
        minWidth: "30rem",
        maxWidth: "30rem",
      },
      minWidth: "80%",
      maxHeight: "13rem",
      minHeight: "13rem",
      margin: "0 1rem",
    },

    postHeader: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      height: "4rem",
      backgroundColor: "#FFFFFF80",
      padding: "1rem",
      width: "100%",
    },

    postInfo: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
      marginLeft: "0.5rem",
    },

    postAvatar: { zIndex: 200 },
    avatar0: { backgroundColor: "#289F9D" },
    avatar1: { backgroundColor: "#F1A35D" },
    avatar2: { backgroundColor: "#ABDCD3" },
    avatar3: { backgroundColor: "#B7D78A" },
    avatar4: { backgroundColor: "#5D7E96" },

    postName: {
      fontSize: "1rem",
      fontWeight: "600",
      margin: 0,
    },

    postDate: {
      fontSize: "0.75rem",
      margin: 0,
    },

    rightAlign: {
      position: "absolute",
      right: 0,
      margin: "auto 0",
      paddingRight: "1rem",
    },

    postBody: {
      backgroundColor: "#F9F9DA",
      boxShadow: "0 8px 8px 2px rgba(0, 0, 0, 0.35)",
      padding: "1rem",
      width: "100%",
      maxHeight: "9rem",
      minHeight: "9rem",
    },

    postFooter: {
      display: "flex",
      alignItems: "center",
      position: "relative",
      width: "100%",
      height: "2.5rem",
    },

    postReady: {
      cursor: "pointer",
      color: "#808080",
      ...bodyHeight,
    },

    postStatic: {
      color: "#252850",
      overflow: "auto",
      ...bodyHeight,
    },

    postEdit: {
      display: "flex",
      minHeight: "7.5rem",
      right: "-0.5rem",
    },

    postEditMain: {
      width: "calc(100% - 2rem)",
    },

    postEditCtrl: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: "2rem",
    },

    textCount: {
      fontSize: "0.75rem",
      margin: "1rem 0.75rem -0.25rem",
    },

    textAttr: mlTextBox,

    inputRoot: {
      margin: 0,
    },

    likeColor: { color: likeColor },
  };
};

export default styles;
